/* ============================= */
/* VERSION V1.2 - FLOATING BUTTONS */
/* Tracking GA4 : appel + scroll top */
/* ============================= */

import React, { useState, useEffect } from "react";
import "../styles/FloatingButtons.css";
import { trackEvent } from "../utils/analytics";

const FloatingButtons = () => {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 350);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {

    trackEvent("click_scroll_top", {
      event_category: "navigation",
      event_label: "floating_scroll_top",
      value: 1
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="floating-buttons">

      {/* APPEL */}
      <a
        href="tel:+33749424919"
        className="floating-call"
        aria-label="Appeler Taxi de la Douce"
        onClick={() =>
          trackEvent("click_call", {
            event_category: "contact",
            event_label: "floating_call",
            value: 1
          })
        }
      >
        📞
      </a>

      {/* RETOUR HAUT */}
      {visible && (
        <button
          className="floating-top"
          onClick={scrollTop}
          aria-label="Retour en haut"
        >
          ↑
        </button>
      )}

    </div>
  );
};

export default FloatingButtons;
